/**
 * @deprecated
 * ## Deprecated
 * Seems to be either broken or replaced. TODO SALES-757
 *
 * ## Description
 * Makes an element sticky to the top of the page. Place the `sw-sticky` attribute on
 * the parent element such as the body tag. Then, place the `sw-sticky-top` attribute
 * on the child element. The child will be sticky to the top of the parent.
 *
 * ```
 * <body sw-sticky>
 *  <sw-card sw-sticky-top>
 *    Content Goes Here
 *  </sw-card>
 * </body>
 * ```
 */
angular
  .module('coreModule')
  .directive(
    'swSticky',
    ($window: ng.IWindowService, $document: ng.IDocumentService) => {
      return {
        restrict: 'A',
        link: function (scope, elem) {
          let wrapper = elem;
          let nodename = elem.eq(0)[0].nodeName.toLowerCase();

          if (nodename === 'body') {
            wrapper = angular.element($window);
          }

          wrapper.on('scroll', () => {
            // Disable on mobile devices
            if ($window.innerWidth < 800) {
              return;
            }

            let stickers_all = $document[0].querySelectorAll('[sw-sticky-top]');
            let scrollHeight = $window.scrollY;
            if (stickers_all.length) {
              angular.forEach(stickers_all, (value: any) => {
                value.style.marginTop = `${scrollHeight}px`;
              });
            }
          });
        },
      };
    },
  );
